import { render } from "./ImpersonationManager.vue?vue&type=template&id=130c573e&scoped=true"
import script from "./ImpersonationManager.vue?vue&type=script&lang=ts"
export * from "./ImpersonationManager.vue?vue&type=script&lang=ts"

import "./ImpersonationManager.vue?vue&type=style&index=0&id=130c573e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-130c573e"

export default script